import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { BlackButtonComponent } from "../../components";
import useBasicDetailsScreen from "./hooks/basic-details";
import MerchantDetailsForm from "../../components/shared/basic-details-form/basic-details-form";
import { RootState } from "store";
import { appendDetails } from "services/MerchantHostApi";
import { updateInitialState } from "slice/merchantSlice";
import { containsPropertyMerchant, getChangedFields } from "utils/index";
import { useNavigate } from "react-router";

const MerchantBasicDetailsScreen = () => {
  const { formik } = useBasicDetailsScreen();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userDetails = useSelector(
    (state: RootState) => state.appLayout.userDetails
  ) as any;
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(formik.values);

  const handleOtpVerification = (otp: string) => {
    if (otp) {
      setIsOtpVerified(true);
      setIsOtpDialogOpen(false);
      toast.success("OTP Verified Successfully!");
    } else {
      toast.error("Incorrect OTP. Please try again.");
    }
  };

  const handleSubmit = async () => {
    if (!formik.isValid) {
      toast.error("Please fill in all required fields correctly.");
      return;
    }
    //check if user hasn't added primary or secondary number then ask them to add that 
    if (
      !formik.values.primaryNumber ||
      (formik.values.primaryNumber === "")
    ) {
      toast.error(
        "Please add primary contact number."
      );
      return;
    }
    const changedFields = getChangedFields(initialValues, formik.values);

    setLoading(true);
    try {
      const data: any = {
        merchantBasicDetails: {
          ...formik.values,
          primaryNumber:undefined,
          secondaryNumber:undefined,
          updatedItems: changedFields,
        },
        primaryNumber: formik.values.primaryNumber,
        secondaryNumber: formik.values.secondaryNumber,
      };
      const val = containsPropertyMerchant(userDetails, "merchantBasicDetails");

      if (val === "UPDATE") {
        data.kycStatus = "UPDATE";
      } else if (val === "TRUE") {
        data.kycStatus = "COMPLETED";
      }

      const response = await appendDetails(
        userDetails.userType,
        userDetails.userId,
        data
      );

      if (response?.message === "Item updated successfully") {
        toast.success("Merchant details updated successfully!");
        dispatch(updateInitialState(response?.updatedItem));
        setInitialValues(formik.values);
        // navigate("/merchant-kyc-details");
        window.location.reload();
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(
        "Failed to update details. Please check your network and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" rowGap={2}>
      <Typography variant="h5" mb={2}>
        Merchant Basic Details
        <Typography variant="subtitle1" fontFamily={"Inter"} fontWeight={"500"} fontSize={16} display={"inline"} ml={1} >
          (Details of Owner/Director)
        </Typography>{" "}
      </Typography>

      <MerchantDetailsForm
        formik={formik}
        isPasswordOpen={isPasswordOpen}
        setIsPasswordOpen={setIsPasswordOpen}
        setIsOtpDialogOpen={setIsOtpDialogOpen}
        isMobileVerified={userDetails.isMobileVerified}
      />

      <Box textAlign="right" display="flex" justifyContent="end" columnGap={2}>
        <BlackButtonComponent
          onClick={handleSubmit}
          btnText={loading ? "Submitting..." : "Submit"}
          sx={{ padding: "6px 40px" }}
          disabled={loading}
        />
      </Box>
    </Box>
  );
};

export default MerchantBasicDetailsScreen;
